import { DynamicObjectType } from 'types/commons';
import { del, get, patch, post } from './utils';

export async function getAllApi(resource, data) {
  return get(`/${resource}`, data);
}

export async function getDataByIdApi(resource, id, suffix = '', data) {
  return get(`/${resource}/${id}${suffix}`, data);
}

export async function delApi(
  resource,
  id,
  suffix = '',
  hasNotUseId,
  data = {},
) {
  if (id && !hasNotUseId) {
    return del(`/${resource}/${id}${suffix}`, data);
  }
  return del(`/${resource}`, data);
}

export async function postApi(resource, suffix = '', data = {}) {
  return post(`/${resource}${suffix}`, data);
}

export async function putApi(resource, id, suffix = '', data = {}) {
  return patch(`/${resource}/${id}${suffix}`, data);
}

export async function exportExcelApi(resource, data = {}) {
  return get(`/${resource}/exportExcel`, data);
}

export const exportExcel = ({
  method = 'GET',
  name,
  query,
  callback,
  body,
} : {
  method?: string;
  name?: string;
  query?: string;
  callback?: () => void;
  body?: DynamicObjectType;
}) => {
  const request = new XMLHttpRequest();
  request.open(method, `${process.env.REACT_APP_SERVER_URL}${query}`);
  request.setRequestHeader(
    'Authorization',
    `Bearer ${localStorage.getItem('devtify-token')}`,
  );
  request.setRequestHeader('Content-Type', 'application/json');
  request.responseType = 'arraybuffer';
  request.onerror = () => {
    callback?.();
  };
  request.onload = () => {
    if (request.status >= 400) {
      callback?.();
    }
    if (request.status === 200 || request.status === 201) {
      const filename = `${name}.xlsx`;
      // The actual download
      const blob = new Blob([request.response], {
        type: request.getResponseHeader('content-type'),
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      callback?.();
    }
  };
  if (method === 'POST' && body) {
    request.send(JSON.stringify(body));
  } else {
    request.send();
  }
};

export const calStockApi = () => {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open('POST', `${process.env.REACT_APP_SERVER_URL}/sync-stock/cal-stock`);
    request.setRequestHeader(
      'Authorization',
      `Bearer ${localStorage.getItem('devtify-token')}`,
    );
    // request.responseType = 'arraybuffer';
    request.onerror = () => {
      reject({
        status: request.status,
        statusText: request.statusText
    });
    };
    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        resolve(request?.responseText);
      }
      if (request.status === 200) {
        reject({
          status: request.status,
          statusText: request.statusText
      });
      }
    };
    request.send();
  })
};
